// extracted by mini-css-extract-plugin
export default {"fade":"Loader_fade__nlQkK","container":"Loader_container__n-tt9"};